/**
 * 页面头部
 */

import Header from './Header.vue';

export default Header;